export function OptionCard({
  checked,
  description,
  name,
  onChange,
  title,
  value,
}: {
  checked: boolean;
  description: string;
  name: string;
  onChange: (value: string) => void;
  title: string;
  value: string;
}) {
  return (
    <label className="flex min-h-[70px] cursor-pointer items-center gap-3 rounded-xl border border-[#b8c5d4] bg-white px-4 py-3 transition-colors hover:border-[#0f4694]">
      <span className="relative flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-[#4a759f]">
        <input
          type="radio"
          name={name}
          value={value}
          checked={checked}
          onChange={() => onChange(value)}
          className="sr-only"
        />
        {checked && <span className="h-3.5 w-3.5 rounded-full bg-[#4a759f]" />}
      </span>
      <span className="min-w-0">
        <span className="block text-base font-medium leading-tight text-black">{title}</span>
        <span className="block text-sm leading-tight text-[#424242]">{description}</span>
      </span>
    </label>
  );
}
